module.exports = __webpack_public_path__ + "error.801b9042.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/error.png
// module id = 2483
// module chunks = 0